// sharePdf.js — v242.13.0
// Native (iOS/Android): render the SAME document HTML into a real PDF using a
// WKWebView-based renderer (full CSS, waits for load), then hand it to the
// proven saveOrShareBlob() path (cache write + system Share sheet: Save to
// Files / Print / share). This replaces the print-formatter approach, which
// rendered blank because it can't lay out modern CSS.
//
// Returns true when handled natively; callers fall through to the web print
// path when this returns false (web is unchanged).
//
// The PDF plugin is imported dynamically so the web bundle never loads it.

import { Capacitor } from '@capacitor/core'
import { saveOrShareBlob } from './saveOrShareBlob'

function base64ToBlob(base64, mime = 'application/pdf') {
  const bytes = atob(base64)
  const arr = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i)
  return new Blob([arr], { type: mime })
}

// v242.88.0: `opts` ({ text, title, dialogTitle }) is forwarded to the share
// sheet so a generated PDF can be sent WITH a message — see TF b34 #14.
export async function sharePdfFromHtml(html, fileName, opts = {}) {
  if (!Capacitor.isNativePlatform()) return false
  const { PdfGenerator } = await import('@capgo/capacitor-pdf-generator')
  const safe = (fileName || 'Orella_Document').replace(/[^a-zA-Z0-9_-]+/g, '_')
  const result = await PdfGenerator.fromData({
    data: html,
    documentSize: 'A4',
    orientation: 'portrait',
    type: 'base64',
    fileName: `${safe}.pdf`,
  })
  const base64 = result?.base64 || result?.value || result?.data || ''
  if (!base64) throw new Error('PDF generation returned no data')
  await saveOrShareBlob(base64ToBlob(base64), `${safe}.pdf`, opts)
  return true
}
